import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { formattedDate, nanoToMilli } from '../../../../utils/helpers';
import { getMapping } from '../../../../utils/runtime-mappings';

// Project stage's icons
import stage1 from '../../../../assets/image/stages/stage1.svg';
import stage2 from '../../../../assets/image/stages/stage2.svg';
import stage3 from '../../../../assets/image/stages/stage3.svg';
import stage4 from '../../../../assets/image/stages/stage4.svg';
import stage5 from '../../../../assets/image/stages/stage5.svg';
import stage6 from '../../../../assets/image/stages/stage6.svg';
import stage7 from '../../../../assets/image/stages/stage7.svg';

const StageTimeline = ({ stages, runtimeFields }) => {
  const { currentVotingStage, currentPeriod, isStagesFinished, isLastValidationBegins } = runtimeFields;
  const translate = useIntl();
  const [images, setImages] = useState([stage1, stage2, stage3, stage4, stage5, stage6, stage7]);

  const processStageTimeLine = () => {
    if (stages.length > images.length) {
      const imagesCopy = [...images];
      const middleId = Math.round(imagesCopy.length / 2) - 1;
      const imagesRest = new Array(stages.length - images.length).fill(stage4, 0, stages.length - images.length);
      imagesCopy.splice(middleId, 0, ...imagesRest);
      setImages(imagesCopy);
    } else if (stages.length < images.length) {
      const imagesCopy = [...images];
      const middleId = Math.floor(stages.length / 2);
      const numberToDelete = images.length - stages.length;
      imagesCopy.splice(middleId, numberToDelete);
      setImages(imagesCopy);
    }
  };

  const getStageUpload = (stageData) => {
    const isDataUploadExist = stageData.data_upload_at;
    return (
      <div className={`upload-item ${isDataUploadExist ? 'upload-item-confirmed' : ''}`}>
        {isDataUploadExist ? <i className="icon-check-circle" /> : null}
      </div>
    );
  };

  const getPastStageResolution = (stageData) => {
    const lastPeriodId = stageData.last_completed_period;
    const lastPeriod = stageData.periods[lastPeriodId];
    const isAffirm = +lastPeriod.voting_affirm_amount > +lastPeriod.voting_deny_amount;
    return (
      <div className={`approve-item ${isAffirm ? 'approve-item-active' : 'approve-item-lost'}`}>
        <span className="approve-item-text">{isAffirm ? translate.formatMessage({ id: 'stageTimeline.affirm' }) : translate.formatMessage({ id: 'stageTimeline.deny' })}</span>
      </div>
    );
  };

  const getVotingStageResolution = (stageData) => {
    const currentPeriodId = getMapping(currentPeriod);
    const isFinished = getMapping(isStagesFinished);
    const isLastVotingBegins = getMapping(isLastValidationBegins);
    const lastPeriodId = stageData.last_completed_period;
    const isDataUploadExist = stageData.data_upload_at;
    const diff = currentPeriodId - lastPeriodId;
    if (isFinished && !isLastVotingBegins) return <div className="approve-item" />; // Last voting stage condition
    if (!isDataUploadExist || currentPeriodId === -1 || diff > 1) {
      return getPastStageResolution(stageData);
    }
    return <div className="approve-item" />;
  };

  const getStageStatus = (stageData, stageId) => {
    const votingStageId = getMapping(currentVotingStage);
    const isFinished = getMapping(isStagesFinished);
    if (stageId === votingStageId) {
      return getVotingStageResolution(stageData);
    }
    if (stageId < votingStageId || isFinished) {
      return getPastStageResolution(stageData);
    }
    return <div className="approve-item" />;
  };

  const getStageDuration = (stageData) => {
    const now = Date.now();
    const stageStart = nanoToMilli(stageData.starts_at);
    const stageEnd = nanoToMilli(stageData.ends_at);
    return (
      <div className={`term-item ${now >= stageStart ? 'term-item-past' : ''}`}>
        <span className="term-item-start">{formattedDate(stageStart, '/')}</span>
        <span className="term-item-end">{formattedDate(stageEnd, '/')}</span>
      </div>
    );
  };

  useEffect(() => {
    processStageTimeLine();
  }, []);

  return (
    <>
      <div className="stage-titles">
        <span className="title-item">{translate.formatMessage({ id: 'stageTimeline.stage' })}</span>
        <span className="title-item">{translate.formatMessage({ id: 'stageTimeline.upload' })}</span>
        <span className="title-item">{translate.formatMessage({ id: 'stageTimeline.status' })}</span>
        <span className="title-item">{translate.formatMessage({ id: 'stageTimeline.startEnd' })}</span>
      </div>
      <div className="stage-list">
        {stages.map((item, id) => (
          <div className="stage-item" key={item.starts_at}>
            <div className="stage-image">
              <img src={images[id]} alt="" />
            </div>
            {getStageUpload(item)}
            {getStageStatus(item, id)}
            {getStageDuration(item)}
          </div>
        ))}
      </div>
    </>
  );
};

export default StageTimeline;
